import React from 'react';
import { getElementFields } from '../../forms/utils/getElementFields';
import { SmartformElementData, ValidationType } from '../../types';
import { CheckboxField } from '../../fields';

export const Checkbox: React.FC<SmartformElementData> = (props) => {
  const [field] = getElementFields(props).required;

  return (
    <CheckboxField
      name={field.name}
      helpText={field.helpText}
      infoText={field.infoText}
      type={field.meta?.validation?.type === ValidationType.NUMBER ? 'number' : 'text'}
      label={field.label}
      required={field.validation.required}
    />
  );
};
